import Parse from "parse";

type OD3_Tenant = Parse.Object;

export interface Wheelchair_AccessibleAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  description: string;
  tenant: OD3_Tenant;
  value: number;
}

export class Wheelchair_Accessible extends Parse.Object<Wheelchair_AccessibleAttributes> {
  static className: string = "OD3_GTFS_Wheelchair_Accessible";

  constructor(data?: Partial<Wheelchair_AccessibleAttributes>) {
    super(
      "OD3_GTFS_Wheelchair_Accessible",
      data as Wheelchair_AccessibleAttributes
    );
  }

  get description(): string {
    return super.get("description");
  }
  set description(value: string) {
    super.set("description", value);
  }
  get tenant(): OD3_Tenant {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant) {
    super.set("tenant", value);
  }
  get value(): number {
    return super.get("value");
  }
  set value(value: number) {
    super.set("value", value);
  }
}

Parse.Object.registerSubclass(
  "OD3_GTFS_Wheelchair_Accessible",
  Wheelchair_Accessible
);
